























import { Component, Vue } from "vue-property-decorator";
import axios from "axios";
import { AxiosResponse, AxiosError } from 'axios'
import Cookies from "js-cookie";
import Obfuscation from '../components/Obfuscation.vue';
import Security from '../components/Security.vue';
import Profiles from '../components/Profiles.vue';
import ServerMod from '../components/ServerMod.vue';

@Component({
  components: {
    Obfuscation,
    Security,
    Profiles,
    ServerMod
  }
})
export default class Dashboard extends Vue {

  private token = Cookies.get("sqfsafe_auth");
  private currentTab = "obfuscation";

  private created() {
    if (!this.token) {
      this.$router.push('/');
      return;
    }

    axios.post('https://sqfsafe.com/api/auth/authenticated').then((response: any) => {
      if (!response.data.success || !response.data.authenticated) {
        this.$router.push('/login');
        return;
      }
    });
  }


};

